<template>
  <component
    :is="link ? 'router-link' : 'button'"
    :type="!link ? type : false"
    :to="localizedRoute(link)"
    class="no-outline button-mini block brdr-none w-100 px10 py10 bg-cl-korzyna-green ripple weight-400 h4 cl-white sans-serif fs-medium"
    :class="{ 'no-underline pointer align-center border-box': link, 'disabled': disabled, 'button-disabled': disabled }"
    data-testid="subscribeSubmit"
    :disabled="disabled"
  >
    <slot>
      {{ 'Add To Cart' }}
    </slot>
  </component>
</template>

<script>
import focusClean from 'theme/components/theme/directives/focusClean'
export default {
  name: 'MiniButtonFull',
  directives: { focusClean },
  props: {
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    link: {
      type: Object,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    qty: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
  .button-mini {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
    border-radius: 10px;
  }
</style>
